import { Component } from "@angular/core";
import {  ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "administration-component",
  templateUrl: "./administration.component.html",  
  standalone: true,
  imports: [],
})
export class AdministrationComponent {
  title = "Administration";
  links: any[] = [];
  activeTab: string = "userRequests"; // Default to the first tab

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  navigate(url: string) {
    this.router.navigate([url], { relativeTo: this.route.parent });
  }
}
